import * as yup from 'yup'

const passwordValidation = yup
	.string()
	.required('La contraseña es requerida')
	.min(8, 'La contraseña debe tener mínimo 8 caracteres')
	.max(30, 'La contraseña debe tener máximo 30 caracteres')
	.matches(/[a-z]/, 'Debe tener al menos una letra minúscula')
	.matches(/[A-Z]/, 'Debe tener al menos una letra mayúscula')
	.matches(/\d/, 'Debe tener al menos un número')
	.matches(
		/[!@#$%^&*(),.?":{}|<>]/,
		'Debe tener al menos un caracter especial'
	)

const passwordSchema = yup.object().shape({
	code: yup
		.number()
		.typeError('El código debe ser numérico')
		.required('Ingresa el código')
		.test('len', 'El código debe tener 6 dígitos', val => val?.toString().length === 6),
	passwordCurrent: passwordValidation,
	passwordNew: passwordValidation,
	passwordRepeat: yup
		.string()
		.required('Por favor confirma tu contraseña')
		.max(30, 'La contraseña debe tener máximo 30 caracteres')
		.oneOf([yup.ref('passwordNew')], 'Las contraseñas no coinciden'),
})

export default passwordSchema
